import axios from 'axios'

function api_response ({success, message, payload, error}) {
    return {
      success: typeof success !== 'undefined'? success: false,
      message: typeof message !== 'undefined'? message: '', 
      payload: typeof payload !== 'undefined'? payload: null,
      error: typeof error !== 'undefined'? error: null,
    }
  }

export default {
    apiUrl: process.env.VUE_APP_API_URL,

    async get_theme_list (params) {
        if (typeof params === 'undefined') {
            params = {}
        }

        if (typeof params['sort'] === 'undefined') {
            params['sort'] = 'updated_time_desc'
        }

        let result = axios
        .post(`${this.apiUrl}/theme/list`, params)
        .then((response) => {
            return api_response({
            success: true,
            payload: response.data,
            })
        })
        .catch((error) => {
            return api_response({error})
        })

        return result
    },

    async get_latest_news_list () {
        let result = axios
        .post(`${this.apiUrl}/news/list`)
        .then((response) => {
            return api_response({
            success: true,
            payload: response.data,
            })
        })
        .catch((error) => {
            return api_response({error})
        })

        return result
    },

    async get_FAQ_list (page_limit, page_num) {
        let result = axios
        .post(`${this.apiUrl}/frequently-asked-question/list`, {
            page_limit,
            page_num,
            'sort': 'id_asc'
        })
        .then((response) => {
            return api_response({
            success: true,
            payload: response.data,
            })
        })
        .catch((error) => {
            return api_response({error})
        })

        return result
    },

    async get_article_list (param) {
        let result = axios
        .post(`${this.apiUrl}/article/list`, param)
        .then((response) => {
            return api_response({
            success: true,
            payload: response.data,
            })
        })
        .catch((error) => {
            return api_response({error})
        })

        return result
    },

    async get_article_do_list ($id) {
        let param = {
            fk_article_system_id: {
                value: $id,
                action: '='
            }
        }
        let result = axios
        .post(`${this.apiUrl}/article/do/list`, param)
        .then((response) => {
            return api_response({
            success: true,
            payload: response.data,
            })
        })
        .catch((error) => {
            return api_response({error})
        })

        return result
    },
    
    async get_article (id) {
        let result = axios
        .get(`${this.apiUrl}/article/get`, { params: {system_id: id}})
        .then((response) => {
            return api_response({
            success: true,
            payload: response.data,
            })
        })
        .catch((error) => {
            return api_response({error})
        })

        return result
    },

    async get_article_timeline_list (params) {
        let result = axios
        .post(`${this.apiUrl}/article/timeline/list`, params)
        .then((response) => {
            return api_response({
            success: true,
            payload: response.data,
            })
        })
        .catch((error) => {
            return api_response({error})
        })

        return result
    },

    async get_article_coordinate_list (params) {
        let result = axios
        .post(`${this.apiUrl}/article/coordinate/list`, params)
        .then((response) => {
            return api_response({
            success: true,
            payload: response.data,
            })
        })
        .catch((error) => {
            return api_response({error})
        })

        return result
    },

    async get_latest_news_list (params) {
        let result = axios
        .post(`${this.apiUrl}/news/list`, params)
        .then((response) => {
            return api_response({
            success: true,
            payload: response.data,
            })
        })
        .catch((error) => {
            return api_response({error})
        })

        return result
    },

    async get_latest_news (id) {
        let result = axios
        .get(`${this.apiUrl}/news/get`, {params:{id}})
        .then((response) => {
            return api_response({
            success: true,
            payload: response.data,
            })
        })
        .catch((error) => {
            return api_response({error})
        })

        return result
    },

    async get_recommended_article_list (params) {
        let result = axios
        .post(`${this.apiUrl}/recommended-article/list`, params)
        .then((response) => {
            return api_response({
            success: true,
            payload: response.data,
            })
        })
        .catch((error) => {
            return api_response({error})
        })

        return result
    },

    async get_query_term_list () {
        
        let params = {
            scope:{
                value: "frontstage",
                action: "="
            }
        }

        let result = axios
        .post(`${this.apiUrl}/query-term/list`, params)
        .then((response) => {
            return api_response({
            success: true,
            payload: response.data,
            })
        })
        .catch((error) => {
            return api_response({error})
        })

        return result
    },

    async update_browse_times () {
        let result = axios
        .post(`${this.apiUrl}/browse-times/update`, {})
        .then((response) => {
            return api_response({
            success: true,
            payload: response.data,
            })
        })
        .catch((error) => {
            return api_response({error})
        })

        return result
    },
}